import "playground-elements/playground-ide"

customElements.whenDefined("playground-ide").then((klass) => {
  Object.defineProperty(klass.prototype, "content", { get: function() {
    const filename = this.shadowRoot.querySelector("playground-file-editor").filename
    return this.config.files[filename].content
  }})
  
  document.addEventListener("turbo:load", () => {
    // We need to set box-sizing to border-box or the extra padding will show as cut off on the bottom!
    setTimeout(() => {
      for (const playground of document.querySelectorAll("playground-ide")) {
        try {
          playground.shadowRoot.querySelector("#lhs").part = "lhs"
          const fileElement = playground.shadowRoot.querySelector("playground-file-editor")
          fileElement.setAttribute("exportparts", "code-mirror")
          const codeElement = fileElement.shadowRoot.querySelector("playground-code-editor")
          codeElement.setAttribute("exportparts", "diagnostic-tooltip, dialog, code-mirror")
          codeElement.shadowRoot.querySelector(".CodeMirror").part = "code-mirror"
        } catch {}
      }
    }, 1000) // We'll be generous. If it STILL didn't work in 1 second, oh well!
  })
})
